/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ExternalImportAnimal} from "../../../_models/external-import-animal";

@Component({
  selector: 'app-table-validate-animals',
  templateUrl: './table-validate-animals.component.html',
  styleUrls: ['./table-validate-animals.component.scss']
})
export class TableValidateAnimalsComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() data: ExternalImportAnimal[];

  @Output() needPayment = new EventEmitter<boolean>();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor() {
    // This is intentional
  }

  ngOnInit() {
    this.needPayment.emit(0 < this.totalAmount);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get autopsyColDisplay(): boolean {
    return this.data ? 0 < this.data.filter((value) => value && value._embedded && value._embedded.autopsy).length : false;
  }

  get totalAmount(): number {
    return this.data ? this.data.map(it => it.amount ? it.amount : 0).reduce((a, b) => a + b) : 0;
  }

}
